module.exports = __webpack_public_path__ + "static/img/brand-fourth-4.22d2cf9c.png";